<div class="container">
  <form #sessionForm="ngForm" (ngSubmit)="onSubmit(sessionForm)">
    
    <div class="form-section">
      <h2>Session Information</h2>

      <div class="form-group" *ngIf="canManageOtherSessions">
        <label for="username">Who is this session for?</label>
        <select
          id="username"
          name="username"
          [(ngModel)]="sessionData.username"
          #username="ngModel">
          <option *ngFor="let u of users" [value]="u.username">
            {{ u.firstName }} {{ u.lastName }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="sessionName">Session Name <span class="required">*</span></label>
        <input
          type="text"
          id="sessionName"
          name="sessionName"
          required
          placeholder="Enter session label"
          [(ngModel)]="sessionData.label"
          #sessionName="ngModel"
          [class.invalid]="sessionName.invalid && sessionName.touched"
          [class.valid]="sessionName.valid && sessionName.touched"
        />
        <div class="error" *ngIf="sessionName.invalid && sessionName.touched">
          Session name is required.
        </div>
      </div>

      <div class="form-group">
        <label for="notes">Description</label>
        <textarea
          id="description"
          name="description"
          placeholder="What do you plan to work on?"
          [(ngModel)]="sessionData.description"
          #notes="ngModel"
        ></textarea>
      </div>
    </div> 

    <div class="button-group">
      <button type="submit" class="btn-primary" [disabled]="sessionForm.invalid">
        Save Session
      </button>
      <button type="button" class="btn-secondary" (click)="resetForm(sessionForm)">
        Cancel
      </button>
    </div>
  </form>
</div>
